import { Card, CardContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import theme from "../../../theme";
import { convertPhoneNumber } from "../../../utils/methods/convertPhoneNumber";

const SellerDetails = ({
  data,
  car
}) => {
  const { t } = useTranslation('agentDetails');

  return (
    <Card 
      sx={{ 
        borderRadius: "1rem", 
        backgroundColor: "#F8F8F8",
        width: "100%",
        padding: "1rem",
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          fontWeight={600}
          color={theme.palette.primary.main}
          marginBottom="1rem"
          textAlign={"center"}
        >
          {t('Seller Information')}
        </Typography>
        <Typography fontWeight={700} color={theme.palette.text.primary}>
          {t('Seller Name:')}
        </Typography>
        <Typography marginBottom="1rem" color={theme.palette.text.primary}>
          {data?.Seller_FName} {data?.Seller_LName}
        </Typography>

        <Typography fontWeight={700} color={theme.palette.text.primary}>
          {t('Contact Number:')}
        </Typography>
        <Typography marginBottom="1rem" color={theme.palette.text.primary}>
          {data?.Seller_Phone ? `${convertPhoneNumber(data.Seller_Phone)}` : t("N/A")}
        </Typography>

        <Typography fontWeight={700} color={theme.palette.text.primary}>
          {t('Postal code:')}
        </Typography>
        <Typography marginBottom="1rem" color={theme.palette.text.primary}>
          {data?.Seller_PostalCode ? data?.Seller_PostalCode : t("N/A")}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default SellerDetails;